import Vue from "vue";
import Vuex from "vuex";
import { tokenUserDetail, loginUserProjectList } from "@/api/login.js";
Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    token: "",
    projectId: null,
    user: {},
    UserProjectList: [],
    currentProject: {},
    notifyRefreshRouterKey: "", // 该值用来刷新通知需要刷新的页面
  },
  mutations: {
    setToken(state, token) {
      state.token = token;
    },
    setProjectId(state, projectId) {
      state.projectId = projectId;
    },
    setUser(state, user) {
      state.user = user;
    },
    setUserProjectList(state, UserProjectList) {
      state.UserProjectList = UserProjectList;
    },
    setCurrentProject(state, currentProject) {
      state.currentProject = currentProject;
    },
    setNotifyRefreshRouterKey(state, notifyRefreshRouterKey) {
      state.notifyRefreshRouterKey = notifyRefreshRouterKey;
    },
  },
  getters: {
    getToken(state) {
      return state.token;
    },
    getProjectId(state) {
      return state.projectId;
    },
    getUser(state) {
      return state.user;
    },
    getUserProjectList(state) {
      return state.UserProjectList;
    },
    getCurrentProject(state) {
      return state.currentProject;
    },
    getNotifyRefreshRouterKey(state) {
      return state.notifyRefreshRouterKey;
    },
  },
  actions: {
    setToken({ commit }, token) {
      let _this = this

      // 如果token存在获取user和项目列表
      if (token) {
        tokenUserDetail().then(res => {
          _this.dispatch("setUser", res.data)
          _this.dispatch("refreshUserProjectList")
        }).catch(err => {

        })
      }
      else {
        // 如果token为空了，把user和currentProject置空，项目列表置空
        _this.dispatch("setUser", {})
        _this.dispatch("setCurrentProject", {})
        commit("setUserProjectList", [])
      }
      commit("setToken", token);
    },
    setProjectId({ commit }, projectId) {
      if (this.getters.getUserProjectList.length > 0) {
        for (var i = 0; i < this.getters.getUserProjectList.length; i++) {
          let project = this.getters.getUserProjectList[i]
          if (projectId == project.id) {
            this.dispatch("setCurrentProject", project)
            break
          }
        }
      }

      commit("setProjectId", projectId);
    },
    setCurrentProject({ commit }, currentProject) {
      commit("setCurrentProject", currentProject);
    },
    setUser({ commit }, user) {
      commit("setUser", user);
    },
    refreshUserProjectList({ commit }) {
      let _this = this
      loginUserProjectList().then(res => {
        commit("setUserProjectList", res.data)

        // 当获取项目列表的同时，把currentProject填上
        for (var i = 0; i < res.data.length; i++) {
          let project = res.data[i]
          if (_this.getters.getProjectId == project.id) {
            _this.dispatch("setCurrentProject", project)
            break
          }
        }
      }).catch(err => {

      })
    },
    setNotifyRefreshRouterKey({ commit }, notifyRefreshRouterKey) {
      commit("setNotifyRefreshRouterKey", notifyRefreshRouterKey);
    },
  }
});


// WEBPACK FOOTER //
// ./src/store/index.js